import { render, staticRenderFns } from "./deplete.vue?vue&type=template&id=a0b866c8&scoped=true&"
import script from "./deplete.vue?vue&type=script&lang=js&"
export * from "./deplete.vue?vue&type=script&lang=js&"
import style0 from "./deplete.vue?vue&type=style&index=0&id=a0b866c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b866c8",
  null
  
)

export default component.exports